import React, { Component } from "react";
import dotenv from 'dotenv';
import Helper from '../../DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,
    t_api_req_device_list_by_user_role,
    t_get_stats_restarting_all_devs_by_5days
} from "../../../reducers/dev";
import Accordion from './Accordion'



dotenv.config();

class PageFrontpage extends Component {


  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
  }
  
  componentDidMount(){
    if (this.props.user) this.props.t_api_req_device_list_by_user_role()  

  }



  render() {
        // Check if the user is authenticated or exists
        if (!this.props.user) {
          // Redirect to an external URL
          //window.location.href = "https://google.com";
          window.location.href = process.env.REACT_APP_HOST+"/login";
          return null; // Return null to avoid rendering anything else
        }
    //if (this.props.user) return <Redirect to="/login" />;

    return (
    <div className="container">

      <h4>PageFrontpage</h4>


      <Accordion 
        stats_data = {this.props.dev.stats_data}
        t_get_stats_restarting_all_devs_by_5days = {this.props.t_get_stats_restarting_all_devs_by_5days}
      />


<p>Headline</p>
      <ul>
        <li>Create Electricity Important object</li>
        <li>Place & Electricity state</li>
        <li>devs qty /online status (green/red bullet)</li>
      </ul>

      <p>History Tables 10 days back</p>
      <ul>
        <li>Internet down qty/time for every device + server</li>
        <li><del>Devices restart qty</del></li>
      </ul>

      <p>Graphics & Data for Graphics</p>
      <ul>
        <li>Internet down qty/time for every device + server

        </li>
      </ul>

      <p>Cron task</p>
      <ul>
        <li>Server health. Test internet condition. 
          <ul>
            <li>Create table h_server_internet_condition</li>
            <li>Test google DNS every 1 min. Every bad result insert into table</li>
          </ul>
        </li>
      </ul>

      <p>To Do</p>
      <ul>
        <li>process Events for telegram</li>
      </ul>

      <hr />
      <Helper props={this.props} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,
    t_api_req_device_list_by_user_role,
    t_get_stats_restarting_all_devs_by_5days
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageFrontpage);

//connect(mapStateToProps, mapDispatchToProps)(PageSimpleFinder);

